import React from "react";
import { Link } from "react-router-dom";
import Seo from "../../../utils/seo/Seo";
import { MARKETING_PAGES } from "../../../utils/seo/marketingPages";
import { SITE_URL } from "../../../utils/seo/siteConfig";
import "../../components/seo/seoPages.css";

export default function MarketingPage({ pageKey }) {
  const page = MARKETING_PAGES[pageKey];
  if (!page) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: page.h1,
    description: page.description,
    url: `${SITE_URL}${page.path}`,
  };

  return (
    <>
      <Seo title={page.title} description={page.description} path={page.path} jsonLd={jsonLd} />
      <article className="seo-page">
        <h1>{page.h1}</h1>
        <p className="seo-intro">{page.intro}</p>
        {page.sections.map((s) => (
          <section key={s.h2}>
            <h2>{s.h2}</h2>
            <p>{s.body}</p>
          </section>
        ))}
        <div className="seo-cta">
          <Link to={page.cta.to}>{page.cta.label}</Link>
        </div>
        <nav className="seo-related" aria-label="Related pages">
          <h2>Related resources</h2>
          <ul>
            {page.related.map((r) => (
              <li key={r.path}>
                <Link to={r.path}>{r.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </article>
    </>
  );
}
